import { getLiteral } from 'utils/getLiteral';

/**
 * Transforms backend variables to Topol mergeTags format.
 *
 * @param {Object} variables - Backend variables grouped by entity (e.g., { contacts: [...], companies: [...] })
 * @returns {Array} mergeTags in Topol format
 */
export const transformVariablesToMergeTags = (variables) => {
    if (!variables || typeof variables !== 'object') {
        return [];
    }

    return Object.entries(variables).reduce((acc, [entityKey, items]) => {
        if (!Array.isArray(items) || items.length === 0) {
            return acc;
        }

        const mergeItems = items.map((item) => {
            const label = getLiteral(item.label) || item.id;
            return {
                value: item.id,
                text: label,
                label: label,
            };
        });

        acc.push({
            name: entityKey,
            items: mergeItems,
        });

        return acc;
    }, []);
};
